'use client'

import { ChevronDown } from 'lucide-react'
import React, { useState } from 'react'

import type { GeoBarState } from './geo'

export function GeoControls({ label, current, options }: GeoBarState) {
  const [selected, setSelected] = useState(current ?? '')

  const go = (geo: string) => {
    const url = new URL(window.location.href)
    url.searchParams.set('geo', geo)
    window.location.assign(url)
  }

  const onChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelected(event.target.value)
    go(event.target.value)
  }

  return (
    <div className="ml-auto mr-4 flex shrink-0 items-center gap-x-3 border-r border-white/20 pr-4 font-medium text-white">
      <span role="status">{label}</span>
      <div className="relative flex items-center">
        <select
          aria-label="View the page as another country"
          value={selected}
          onChange={onChange}
          className="h-5 cursor-pointer appearance-none rounded-[4px] border border-white/30 bg-transparent py-0 pl-1.5 pr-6 leading-none text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-civo-lime"
        >
          <option value="" disabled className="text-civo-black">
            Switch country
          </option>
          {options.map((option) => (
            <option key={option.value} value={option.value} className="text-civo-black">
              {option.label}
            </option>
          ))}
        </select>
        <ChevronDown aria-hidden className="pointer-events-none absolute right-1.5 size-3 text-white" />
      </div>
      {/* detect, not clear: it drops the override but keeps these controls outside preview */}
      {current && (
        <button type="button" onClick={() => go('detect')}>
          Clear
        </button>
      )}
    </div>
  )
}
